// extracted by mini-css-extract-plugin
export var box = "_9p-1";
export var checkboxRow = "_9p-8";
export var checked = "_9p-2";
export var descriptionSpacer = "_9p-a";
export var disabled = "_9p-3";
export var icon = "_9p-6";
export var input = "_9p-0";
export var labelSpacer = "_9p-9";
export var medium = "_9p-5";
export var small = "_9p-4";
export var text = "_9p-7";